export default __webpack_public_path__ + "static/media/h2.924d967a.jpeg";